var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          staticClass: "mr-3",
          attrs: { placeholder: "選擇客戶", clearable: "" },
          on: { clear: _vm.onClear, change: _vm.onSelect },
          model: {
            value: _vm._clientId,
            callback: function ($$v) {
              _vm._clientId = $$v
            },
            expression: "_clientId",
          },
        },
        _vm._l(_vm.clients, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.name, value: item.id },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }